import { BaseComponent } from "../../../components/BaseComponent";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileSignature, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import styled from "styled-components";
import { Modal, ModalControls } from "../../../components/Modal";
import { Button } from "../../../components/Buttons";
import { deleteWorkflow } from "../actions";

const ActionsContainer = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const IconWrapper = styled.div`
  color: ${props => (props?.color === 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046')};
`;

export class WorkflowActionsContainerComp extends BaseComponent {

  onClickDeleteBtn(e) {
    this.setState({ removeWorkflowConfirmation: true });
  }

  renderConfirmationModal() {
    if (!this.state.removeWorkflowConfirmation) return '';

    return (
      <Modal onClose={this.setStateFn({ removeWorkflowConfirmation: false })} title={this.lbl(`workflows.overview.deleteConfirmation`)}>
        <ModalControls>
          <Button
            onClick={() => {
              this.props.deleteWorkflow();
              this.setState({ removeWorkflowConfirmation: false });
            }}
            primary
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.setStateFn({ removeWorkflowConfirmation: false })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
  render() {
    return (
      <>
        <ActionsContainer>
          <IconWrapper color={'green'}>
            <div
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faFileSignature} />
            </div>
          </IconWrapper>
          <IconWrapper color={'red'}>
            <div
              onClick={evt => {
                evt.stopPropagation();
                this.onClickDeleteBtn(evt);
              }}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
          </IconWrapper>
        </ActionsContainer>
        {this.renderConfirmationModal()}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    deleteWorkflow() {
      dispatch(deleteWorkflow(ownProps.workflow.id))
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const WorkflowActionsContainer = compose(withConnect, withRouter)(WorkflowActionsContainerComp);
